export default "__VITE_ASSET__DCd9l7_Q__"